<template>
    <div>
            <h3 class="text-center" v-if="user && logoutSuccess">
                <i aria-hidden="true" class="fa fa-chevron-left "></i><i aria-hidden="true" class="fa fa-chevron-left "></i><i aria-hidden="true" class="fa fa-chevron-left "></i>
                Logging out ..
                <i aria-hidden="true" class="fa fa-chevron-left "></i><i aria-hidden="true" class="fa fa-chevron-left "></i><i aria-hidden="true" class="fa fa-chevron-left "></i>
            </h3>
        </div>
        <!--<alert v-model="validationSuccess" placement="top-right" duration="2000" type="success" width="400px" dismissable>-->
            <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
            <!--<strong>Thank You! Your Account has been validated</strong>-->
            <!--<p id="validation_successmsg">Now login to Tone Networks to watch our awesome videos</p>-->
        <!--</alert>-->
        <!--<div class="form">-->
            <!--<form v-on:submit.prevent="onSubmit">-->
                <!--<div class="validateField">-->
                    <!--<bs-input v-model="user.email"-->
                              <!--id = "validate_email"-->
                              <!--type="email"-->
                              <!--class="form-input"-->
                              <!--error="Email is Required"-->
                              <!--placeholder="Email Address"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                    <!--<bs-input v-model="user.validationCode"-->
                              <!--id = "validate_validationcode"-->
                              <!--type="text"-->
                              <!--class="form-input"-->
                              <!--error="Code is Required"-->
                              <!--placeholder="Validation Code"-->
                              <!--required-->
                              <!--icon>-->
                    <!--</bs-input>-->
                <!--</div>-->
                <!--<div>-->
                    <!--<button class="btn formButton" id="validate_button">-->
                        <!--Submit-->
                        <!--&lt;!&ndash;<spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>&ndash;&gt;-->
                    <!--</button>-->
                <!--</div>-->
            <!--</form>-->
            <!--<alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>-->
                <!--<span class="icon-info-circled alert-icon-float-left"></span>-->
                <!--<strong>Error:</strong>-->
                <!--<p id="login_errormsg">{{error.message}}</p>-->
            <!--</alert>-->
        <!--</div>-->
</template>

<script>
import alert from '@/accessibility/Alert'
import spinner from '@/accessibility/Spinner'
import input from '@/accessibility/Input'
import { mapGetters } from 'vuex'
// import store from '../store'

export default {
    components: {
        'bs-input': input,
        alert,
        spinner
    },
    name: 'validate',
    data: function () {
        return {
            logoutSuccess: false
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user'
        ])
    },
    methods: {
    },
    mounted: function () {
        let self = this
        if (self.user && navigator.userAgent.indexOf('gonative') > -1) {
            self.$store.dispatch('LOGOUT', this.user).then(() => {
//                setTimeout(() => {
//                    this.$router.push('/')
//                }, 1500)
            })
        } else {
            this.$router.push('/')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .validate .form{
        text-align: left;
        width: 40%;
        margin: 50px auto;
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .validate h1{
        font-size: 32px;
        color: #009cf6;
        font-weight: lighter;
        margin: 0 0 25px 0;
    }
    .validate p{
        font-size: 14px;
        color: #979797;
        margin: 0;
    }
    .padding-minus{
        padding:0;
    }
    .validate .form .form-input{
        margin-bottom: 25px ;
    }
    .validate .form .forgotPassword{
        float: right;
        color: black
    }
    .validate .form .forgotPassword:hover{
        float: right;
        color: #337ab7;
    }
    .formButton{
        margin: 25px 0 50px;
        width: 130px;
        height: 47px;
        color: #91ab45;
        border-color: #91ab45;
        background-color: transparent;
        transition: 0.5s;
        padding:0;
    }
    .formButton a{
        display: block;
        padding: 13px 12px;
        color: #91ab45;
        text-decoration: none;
        transition: 0.5s;
    }
    .formButton:hover{
        border-color: #91ab45;
        background-color: #91ab45;
        transition: 0.5s;
        color: #ffffff;
    }
    .btn-spinner{
        bottom:15px
    }
</style>



// WEBPACK FOOTER //
// Logout.vue?27fa435f